export default __webpack_public_path__ + "static/media/header.94417c37.png";